import * as React from 'react'

import { PostCard } from '@thg-commerce/enterprise-widget-post-cards'
import {
  formatDistanceToNow,
  getContentRoutePathname,
  useFormattableI18nProperty,
  Routes,
  useSiteDefinition,
} from '@thg-commerce/enterprise-core'
import { styled, Text } from '@thg-commerce/enterprise-theme'

interface PostCardRendererProps {
  items: {
    categoryUri: string
    categoryName: string
    postUri: string
    title: string
    excerpt: string
    date: string
    displayName: string
    username: string
    image?: string
  }[]
  title?: string
  isAmp: boolean
}

const Title = styled.h3`
  ${Text('large2', 'alternate')}
`

export const PostCardRenderer = (props: PostCardRendererProps) => {
  const { contentRoutePrefix } = useSiteDefinition()

  const i18nText = {
    authorText: useFormattableI18nProperty('content.authorprefix.text'),
  }

  const placeholderImage = `data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'%3E%3Crect width='1' height='1' fill='%23f2f2f2' /%3E%3C/svg%3E`

  const postCards = props.items.map((item, index) => {
    const article = {
      title: item.title,
      i18nAuthorText: i18nText.authorText(item.displayName),
      category: item.categoryName,
      description: item.excerpt,
      articleAge: formatDistanceToNow(new Date(item.date), {
        addSuffix: true,
      }),
      image: {
        isAmp: props.isAmp,
        src: [{ url: item?.image ? item.image : placeholderImage }],
        alt: '',
      },
      articleUrl: getContentRoutePathname(contentRoutePrefix, item.postUri),
      categoryUrl: getContentRoutePathname(
        contentRoutePrefix,
        item.categoryUri,
      ),
      authorUrl: getContentRoutePathname(
        contentRoutePrefix,
        Routes.BlogAuthor.replace(':slug', item.username),
      ),
    }

    return <PostCard article={article} key={index} data-testid="post-card" />
  })

  return (
    <React.Fragment>
      {props.title && <Title>{props.title}</Title>}
      {postCards}
    </React.Fragment>
  )
}
